enum TreeViewType {
	MOUVEMENT = 'mouvement',
}

export default TreeViewType;
